import React from 'react'
import { Unstable_Grid2 as Grid, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import cx from 'clsx'
import HandleMarkup from '@src/components/HandleMarkup'
import { ProductAttribute } from '@src/types/graphql-types'
import MapSrpAttributeValues from '@src/components/MapSrpAttributeValues'

const useStyles = makeStyles()((theme) => ({
  container: {
    columnGap: theme.spacing(4),
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    marginTop: theme.spacing(4),
    rowGap: theme.spacing(1),
  },
  label: {
    color: theme.palette.common.black,
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    wordBreak: 'break-word',
  },
  value: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  geneSequence: {
    fontFamily: theme.typography.fontFamily,
  },
}))

type NewSrpKeyAttributesProps = {
  keyAttributes?: ProductAttribute[]
}

const NewSrpKeyAttributes = ({
  keyAttributes = [],
}: NewSrpKeyAttributesProps) => {
  const { classes } = useStyles()

  if (!keyAttributes.length) return null

  return (
    <Grid
      container
      className={classes.container}
      data-testid="new-srp-key-attributes"
    >
      {keyAttributes.map((attr, index) => {
        const values = attr.values
        const geneSequence =
          typeof attr.label === 'string' &&
          attr.label.toLowerCase().includes('sequence')

        return (
          <React.Fragment key={index}>
            <Typography
              variant="caption"
              component="div"
              className={classes.label}
            >
              <HandleMarkup value={attr.label} />
              {':'}
            </Typography>
            <Typography
              variant="caption"
              component="div"
              className={classes.value}
            >
              <MapSrpAttributeValues
                values={values}
                className={cx({
                  [classes.geneSequence]: geneSequence,
                })}
              />
            </Typography>
          </React.Fragment>
        )
      })}
    </Grid>
  )
}

export default NewSrpKeyAttributes
